/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';

/**
 * Spinner component for displaying a centered loading spinner during initial app load
 * Used only during the initial loading phase (API fetch + START message send)
 */
const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-content">
        <div className="spinner" />
        <p className="spinner-message">Loading your chatbot. This may take a minute.</p>
      </div>
    </div>
  );
};

export default Spinner;
